// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const NotificationActivitySmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M21 6.666a.75.75 0 0 1-1.01-.321 8.8 8.8 0 0 0-3.137-3.46.75.75 0 1 1 .8-1.27 10.45 10.45 0 0 1 3.668 4.04.75.75 0 0 1-.321 1.01ZM3.348 6.75a.75.75 0 0 0 .665-.405 8.8 8.8 0 0 1 3.137-3.46.75.75 0 1 0-.8-1.27 10.45 10.45 0 0 0-3.668 4.04.75.75 0 0 0 .666 1.095Zm17.447 9.744A1.5 1.5 0 0 1 19.5 18.75h-3.825a3.75 3.75 0 0 1-7.35 0H4.5a1.5 1.5 0 0 1-1.293-2.256C4.052 15.037 4.5 12.964 4.5 10.5a7.5 7.5 0 0 1 15 0c0 2.463.448 4.536 1.295 5.994ZM14.12 18.75H9.879a2.25 2.25 0 0 0 4.242 0Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationActivitySmall_Filled_Corner0_Rounded',
  })

export const NotificationFollowSmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M24 12.75a.75.75 0 0 1-.75.75h-1.5V15a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5a.75.75 0 0 1 1.5 0V12h1.5a.75.75 0 0 1 .75.75Zm-10.5 2.033a6.375 6.375 0 1 0-6.74 0c-1.937.633-3.678 1.817-5.08 3.484a.75.75 0 0 0 .57 1.233H18a.75.75 0 0 0 .575-1.233c-1.402-1.667-3.144-2.85-5.075-3.484Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationFollowSmall_Filled_Corner0_Rounded',
  })

export const NotificationLikeSmall_Filled_Corner0_Rounded = createSinglePathSVG(
  {
    path: 'M22.5 9.563c0 6.562-9.73 11.874-10.145 12.093a.75.75 0 0 1-.71 0C11.23 21.436 1.5 16.125 1.5 9.563A5.82 5.82 0 0 1 7.313 3.75c1.935 0 3.63.833 4.687 2.24 1.057-1.407 2.752-2.24 4.688-2.24A5.82 5.82 0 0 1 22.5 9.563Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationLikeSmall_Filled_Corner0_Rounded',
  },
)

export const NotificationMentionSmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M21.75 12v.143C21.718 13.479 21.222 15 19.125 15c-2.17 0-2.625-1.631-2.625-3V8.25a.75.75 0 0 0-.8-.75.766.766 0 0 0-.7.775v.375a4.5 4.5 0 1 0 .63 6.005 4 4 0 0 0 .318.469c.503.626 1.462 1.376 3.177 1.376a5 5 0 0 0 .864-.07.375.375 0 0 1 .384.562 9.76 9.76 0 0 1-8.569 4.758c-5.136-.103-9.348-4.232-9.546-9.365A9.75 9.75 0 1 1 21.75 12ZM9 12a3 3 0 1 0 3-3 3 3 0 0 0-3 3Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationMentionSmall_Filled_Corner0_Rounded',
  })

export const NotificationQuoteSmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M10.875 6.75V15a4.505 4.505 0 0 1-4.5 4.5.75.75 0 0 1 0-1.5 3 3 0 0 0 3-3v-.75H3.75a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h5.625a1.5 1.5 0 0 1 1.5 1.5Zm9.375-1.5h-5.625a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625V15a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.505 4.505 0 0 0 4.5-4.5V6.75a1.5 1.5 0 0 0-1.5-1.5Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationQuoteSmall_Filled_Corner0_Rounded',
  })

export const NotificationReplySmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M21.75 12a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.192A9.75 9.75 0 1 1 21.75 12Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationReplySmall_Filled_Corner0_Rounded',
  })

export const NotificationRepostSmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M2.25 12A6.76 6.76 0 0 1 9 5.25h9v-1.5a.75.75 0 0 1 1.28-.53l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25A.75.75 0 0 1 18 8.25v-1.5H9A5.256 5.256 0 0 0 3.75 12a.75.75 0 0 1-1.5 0ZM21 11.25a.75.75 0 0 0-.75.75A5.256 5.256 0 0 1 15 17.25H6v-1.5a.75.75 0 0 0-1.28-.53l-2.25 2.25a.75.75 0 0 0 0 1.06l2.25 2.25A.75.75 0 0 0 6 20.25v-1.5h9A6.76 6.76 0 0 0 21.75 12a.75.75 0 0 0-.75-.75Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationRepostSmall_Filled_Corner0_Rounded',
  })

export const NotificationStarterPackSmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M22.125 6.506A1.5 1.5 0 0 0 20.992 6H16.5a4.5 4.5 0 0 0-9 0H3.008a1.5 1.5 0 0 0-1.125.506 1.5 1.5 0 0 0-.368 1.17l1.337 11.25a1.5 1.5 0 0 0 1.5 1.324h15.305a1.5 1.5 0 0 0 1.5-1.324l1.336-11.25a1.5 1.5 0 0 0-.368-1.17ZM9 9.75a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0ZM12 3a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3Zm4.5 6.75a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationStarterPackSmall_Filled_Corner0_Rounded',
  })

export const NotificationVerifiedSmall_Filled_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm4.28 8.03-5.25 5.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 1.06Z',
    viewBox: '0 0 24 24',
    glyph: 'NotificationVerifiedSmall_Filled_Corner0_Rounded',
  })
